export default __webpack_public_path__ + "static/media/torso-low-right-side.343d76d7.png";